/*
* @prop --uic-check-list-item-height: The height.
*/

uic-check-list-item {
  align-content: center;
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  box-sizing: border-box;
  display: flex;
  height: var(--uic-check-list-item-height);
  outline: none;
  padding: 0 8px;
  position: relative;

  uic-checkbox {
    display: flex;
    width: 100%;
  }

  &:focus-visible {
    border-color: var(--uic-color-blue2);
  }
}

.uic-check-list-item {
  &__content-default {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__content-primary {
    font-weight: var(--uic-font-weight-semibold);
  }

  &__icon {
    display: flex;
    margin-right: 8px;
  }
}

[uic-scroll-init] > uic-check-list-item .uic-checkbox__label {
  overflow: visible;
  padding-left: 20px;
}

uic-check-list-item .uic-checkbox__label {
  align-items: center;
  display: flex;
}
